export default __webpack_public_path__ + "static/media/wi-day-cloudy-high.74f1d0cf.svg";